import { render } from "./ArticleDataComp.vue?vue&type=template&id=f34cb694&scoped=true"
import script from "./ArticleDataComp.vue?vue&type=script&lang=js"
export * from "./ArticleDataComp.vue?vue&type=script&lang=js"

import "./ArticleDataComp.vue?vue&type=style&index=0&id=f34cb694&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f34cb694"]])

export default __exports__